import React, { Component } from "react";
import Select from "react-select";

export default class TheSelectDropDown extends Component {
  render() {
    return (
      <Select
        options={this.props.options}
        value={this.props.value}
        onChange={this.props.onChange}
        className="react-select-container checkValidate"
        classNamePrefix="react-select"
        isDisabled={this.props.isDisabled}
      />
    );
  }
}
